export default __webpack_public_path__ + "static/media/jae-cho.3d22eee1.jpg";